import React from 'react';
import { Input } from 'antd';
import { PasswordProps } from 'antd/lib/input';

export default function(props: PasswordProps) {
  return <Input.Password className="wf_password_input" {...props} />;
};

